module.exports = __webpack_public_path__ + "media/images/goutte-desktop-f985a6e3a7a958f7c04fa8cdf9ce42c4.jpg";